var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLines = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 7,
  viewBox: "0 0 20 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  y1: 0.5,
  x2: 19.5,
  y2: 0.5,
  stroke: "currentColor",
  strokeLinecap: "round"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  y1: 6.5,
  x2: 19.5,
  y2: 6.5,
  stroke: "currentColor",
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLines);
export { ForwardRef as ReactComponent };